<!--
  @Description 说明编辑弹窗
  @Date 2021-12-24
  @Author liushuo
-->
<template>
  <vxe-modal v-model="isShow" size="mini" width="60%" height="80%" @show="showWindows" @close="closeWindows" show-zoom>
    <!-- 标题 -->
    <template #title>
      <!-- 问题编号 -->
      <span style="color: #888888">{{ form.num || '新增问题' }}</span>
      <!-- 模块名称 -->
      <span style="margin-left: 10px">{{ form.groupName ? `[${form.groupName}]` : '' }}</span>
      <!-- 页面名称 -->
      <span style="margin-left: 5px">{{ form.vuePath }}</span>
    </template>

    <!-- 编辑区域 -->
    <div class="edit-dv">
      <div class="tips">
        <i class="el-icon-warning" style="color: #6c9eff; margin-right: 3px"></i>
        输入产品、系统版本、模块、页面后，可通过 "匹配" 按钮，来尝试匹配对应解决人
      </div>
      <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
        <!-- 第一行 -->
        <el-row v-if="!ifOnlyShowQuestionContent" :gutter="20">
          <el-col :span="6">
            <el-form-item label="产品" prop="menuArgs">
              <el-select
                clearable
                v-model="form.menuArgs"
                :placeholder="placeholderConfig.select"
                :disabled="false"
                @change="getVersion"
              >
                <el-option
                  :index="item + ''"
                  v-for="item in combobox.menuArgs"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="系统版本" prop="productionVersion">
              <el-select
                clearable
                v-model="form.productionVersion"
                :placeholder="placeholderConfig.select"
                :disabled="false"
                @clear="form.productionVersion = ''"
              >
                <el-option
                  :index="item + ''"
                  v-for="item in combobox.productionVersion"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="模块" prop="groupName">
              <el-input
                v-model="form.groupName"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="页面" prop="vuePath">
              <el-input
                v-model="form.vuePath"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第一行 -->
        <el-row v-if="!ifOnlyShowQuestionContent" :gutter="20">
          <el-col :span="6"
            ><el-form-item label="是否紧急" prop="isPriority">
              <el-select clearable v-model="form.isPriority" :placeholder="placeholderConfig.select" :disabled="false">
                <el-option
                  :index="item + ''"
                  v-for="item in combobox.isPriority"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型" prop="type">
              <el-select clearable v-model="form.type" :placeholder="placeholderConfig.select" :disabled="false">
                <el-option
                  :index="item + ''"
                  v-for="item in combobox.type"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="提出日期" prop="createDate">
              <el-date-picker
                v-model="form.createDate"
                v-date
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="placeholderConfig.input"
                :disabled="false"
              ></el-date-picker>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="截止日期" prop="dueDate">
              <el-date-picker
                v-model="form.dueDate"
                v-date
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="保存后自动计算"
                :disabled="true"
              ></el-date-picker>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第三行 -->
        <el-row v-if="!ifOnlyShowQuestionContent" :gutter="20">
          <el-col :span="6">
            <el-form-item label="前端设计人" prop="frontDesignersArr">
              <el-select
                clearable
                filterable
                v-model="form.frontDesignersArr"
                size="small"
                placeholder="选择前端设计人"
                :disabled="false"
                multiple
                :multiple-limit="2"
              >
                <!-- :disabled="isDisabled('frontEngineerCache')" -->
                <el-option
                  v-for="i of selectOptions.frontEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="后端设计人" prop="backDesignersArr">
              <el-select
                clearable
                filterable
                v-model="form.backDesignersArr"
                size="small"
                placeholder="选择后端设计人"
                :disabled="false"
                multiple
                :multiple-limit="2"
              >
                <!-- :disabled="isDisabled('backEngineerCache')" -->
                <el-option
                  v-for="i of selectOptions.backEngineer"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6"
            ><el-form-item label="技术测试" prop="techTester">
              <el-select
                clearable
                filterable
                v-model="form.techTester"
                size="small"
                placeholder="选择技术测试"
                :disabled="false"
              >
                <!-- :disabled="isDisabled('techTesterCache')" -->
                <el-option
                  v-for="i of selectOptions.techTester"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务测试" prop="businessTester">
              <el-select
                clearable
                filterable
                v-model="form.businessTester"
                size="small"
                placeholder="选择业务测试"
                :disabled="false"
              >
                <el-option
                  v-for="i of selectOptions.businessTester"
                  :key="i.name + ''"
                  :label="i.name"
                  :value="i.value"
                ></el-option>
              </el-select>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第四行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="问题内容" prop="content">
              <el-input
                type="textarea"
                :rows="8"
                v-model="form.content"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
                :disabled="false"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 间隔槽（内含保存按钮） -->
    <div class="button-dv">
      <el-button @click="isShow = false"> 取消 </el-button>
      <el-button @click="matchMenu"> 匹配 </el-button>
      <el-button type="primary" @click="save"> 确认新增 </el-button>
    </div>

    <!-- 协助人选择框 -->
    <CooperatePersonSelect ref="CooperatePersonSelect" :curSelectRowID="id" title="选择协助人"></CooperatePersonSelect>
  </vxe-modal>
</template>

<script>
import CooperatePersonSelect from './CooperatePersonSelect'
import { MessageBox } from 'element-ui'

export default {
  name: 'addNewProblemModal',
  components: {
    CooperatePersonSelect
  },
  props: {
    parentObj: Object,
    // 当前数据行id
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {
        menuArgs: '',
        productionVersion: '',
        groupName: '',
        vuePath: '',
        isPriority: '否',
        type: '完善',
        createDate: new Date(),
        dueDate: '',
        frontEngineer: '',
        backEngineer: '',
        frontDesignersArr: [],
        frontDesigners: '',
        backDesignersArr: [],
        backDesigners: '',
        techTester: '',
        businessTester: '',
        createtor: '',
        content: '',
        comment: ''
      },
      rules: {},
      // 特殊权限
      spcial: false,
      frontEngineerCache: '',
      backEngineerCache: '',
      techTesterCache: '',
      businessTesterCache: '',
      // 下拉框列表
      combobox: {
        // 是否紧急
        isPriority: [
          {
            name: '是',
            value: '是'
          },
          {
            name: '否',
            value: '否'
          }
        ],
        // 类型
        type: [
          {
            name: '完善',
            value: '完善'
          },
          {
            name: '错误',
            value: '错误'
          },
          {
            name: '新增',
            value: '新增'
          },
          {
            name: '性能',
            value: '性能'
          }
        ],
        // 产品
        menuArgs: [],
        // 系统版本
        productionVersion: []
      },
      selectOptions: {
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: []
      }
    }
  },
  methods: {
    // 监听模态框开启
    async showWindows() {
      this.setFormRules()
      // 获取人员下拉框
      this.getPerson()
      this.bindCombobox()
      this.initData()
      // 将刚打开弹窗时的所有人员作为缓存存起来，作为后续判断依据
      // 0107暂时不开启 this.setPersonCache()
    },
    initData() {
      this.form.createtor = this.$store.state.userInfo.userName

      this.form.createDate = this.ykDateFormat('yyyy-MM-dd', new Date())
    },
    // 设置表单校验规则
    setFormRules() {
      this.rules = {
        menuArgs: [{ required: true, message: '请选择产品', trigger: 'change' }],
        productionVersion: [{ required: true, message: '请选择系统版本', trigger: 'change' }],
        groupName: [{ required: true, message: '请输入模块', trigger: 'change' }],
        vuePath: [{ required: true, message: '请输入页面', trigger: 'change' }],
        isPriority: [{ required: true, message: '请选择是否紧急', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        createDate: [{ required: true, message: '请输入提出日期', trigger: 'change' }],
        frontEngineer: [{ required: true, message: '请选择前端研发', trigger: 'change' }],
        backEngineer: [{ required: true, message: '请选择后端研发', trigger: 'change' }],
        frontDesignersArr: [{ required: true, message: '请选择前端研发', trigger: 'change' }],
        backDesignersArr: [{ required: true, message: '请选择后端研发', trigger: 'change' }],
        techTester: [{ required: true, message: '请选择技术测试', trigger: 'change' }],
        businessTester: [{ required: true, message: '请选择业务测试', trigger: 'change' }],
        content: [{ required: true, message: '请输入问题内容', trigger: 'change' }]
      }
    },
    // 获取人员数据
    async getPerson() {
      this.selectOptions.frontEngineer = []
      this.selectOptions.backEngineer = []
      this.selectOptions.techTester = []
      this.selectOptions.businessTester = []

      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      for (let item of res.data.rows) {
        const temp = {
          name: item.name,
          value: item.name
        }
        if (item.post.indexOf('前端研发') > -1) {
          this.selectOptions.frontEngineer.push(temp)
        }
        if (item.post.indexOf('后端研发') > -1) {
          this.selectOptions.backEngineer.push(temp)
        }
        if (item.post.indexOf('技术测试') > -1) {
          this.selectOptions.techTester.push(temp)
        }
        if (item.post.indexOf('业务测试') > -1) {
          this.selectOptions.businessTester.push(temp)
        }
      }
      this.selectOptions.frontEngineer.push({
        name: '/',
        value: '/'
      })
      this.selectOptions.backEngineer.push({
        name: '/',
        value: '/'
      })
      this.selectOptions.techTester.push({
        name: '/',
        value: '/'
      })
      this.selectOptions.businessTester.push({
        name: '/',
        value: '/'
      })
    },
    // 缓存弹窗中的人员，作为后续判断依据，触发时机如下：
    // 1.刚打开弹窗时
    // 2.点击保存后（暂时不用，直接关掉弹窗）
    setPersonCache() {
      // 前端
      this.frontEngineerCache = this.form.frontEngineer
      // 后端
      this.backEngineerCache = this.form.backEngineer
      // 技术测试
      this.techTesterCache = this.form.techTester
      // 业务测试
      this.businessTesterCache = this.form.businessTester
    },
    // 监听模态框关闭
    closeWindows() {
      this.$refs['FormRef'].resetFields()
    },
    // 保存
    async save() {
      if (!this.$parent.Authority.edit) {
        return false
      }

      const isCanSave = await this.validForm()
      if (!isCanSave) return

      this.confirmAdd()
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        () => {
          flag = true
        },
        () => {
          flag = false
        }
      )
      if (!flag) {
        this.$message.warning('验证失败，请检查后重试')
      }
      return flag
    },
    // 打开协助人弹窗
    openCooperatePersonModal() {
      if (!this.$parent.Authority.edit) {
        return false
      }
      this.$refs.CooperatePersonSelect.formVisible = !this.$refs.CooperatePersonSelect.formVisible
    },
    // 确认新增
    confirmAdd() {
      MessageBox.confirm('确认新增吗？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.httpConfirm()
        })
        .catch(() => {
          // do something
        })
    },
    // 发起确认请求
    async httpConfirm() {
      this.form.frontDesigners = this.form.frontDesignersArr.join('、')
      this.form.backDesigners = this.form.backDesignersArr.join('、')
      const form = this.removeObjectNull(this.form)
      const { data: res } = await this.$http.post('/Common/YKCase/insertlist', [form])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      this.$message.success(res.data)
      // 重新刷新主页面
      this.parentObj.getList()
      this.closeModal()
    },
    openModal() {
      this.isShow = true
    },
    closeModal() {
      this.isShow = false
    },
    /**
     * 输入框是否禁用
     * @param {String} property 字段名
     */
    isDisabled(property) {
      const DISABLED = true
      const ABLE = false
      // 对应的解决日期单元格，需对应的值为本人才可操作
      // TODO 获取特殊权限 1.若有特殊权限，则全部允许编辑
      if (this.$parent.specialAuthority.super) {
        return ABLE
      }

      // 2.判断缓存值，若值为 '/' 或为本人，则允许编辑
      if (this[property] === '/' || this[property] === this.curUserName) {
        return ABLE
      }

      return DISABLED
    },
    /**
     * @description 格式化说明
     * @param {String} comment 说明内容
     * @returns Array[{type, date, user, instruction}]
     */
    formatContentWrap(comment) {
      let res = []
      if (comment == null || comment.trim() === '') {
        return res
      }
      // 1.按句分割
      let sentence = comment.split('!#!')
      sentence.forEach(v => {
        // 2.按字段分割，[0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:问题说明id
        const word = v.split('!&!')
        const temp = {
          type: word[0] || '无',
          date: word[1] || '无',
          user: word[2] || '无',
          instruction: word[3] || '无'
        }
        if (this.$store.state?.systemSetting?.explainSort && this.$store.state.systemSetting.explainSort === 'asc') {
          res.unshift(temp)
        } else {
          res.push(temp)
        }
      })
      return res
    },
    async bindCombobox() {
      this.combobox.menuArgs = []
      const { data: res } = await this.$http.get('/Common/BMenuGroup/select-item')
      if (res.isSuccess) {
        for (let item of res.data) {
          switch (item.code) {
            case 'ProductionType':
              this.combobox.menuArgs.push(item)
              break
          }
        }
      }
    },
    //
    /**
     * 获取版本（标准版、专业版、旗舰版等）
     * @param type 产品（如铁塔、电杆）
     */
    async getVersion(type) {
      // 产品改变时，需要清空版本
      this.form.productionVersion = ''
      this.combobox.productionVersion = []
      const { data: res } = await this.$http.post(`/Common/ProductVersionSet/list?sqlTitle=${type}`)
      if (res.isSuccess) {
        for (let item of res.data) {
          this.combobox.productionVersion.push({
            name: item.productionVersion,
            value: item.productionVersion
          })
        }
      }
    },
    // 对数据和模块菜单进行匹配
    async matchMenu() {
      if (!this.isCanMatch()) {
        return
      }

      const MENU_DATA = [this.removeObjectNull(this.form)]
      const { data: res } = await this.$http.post('/Common/YKCase/excelcreate', MENU_DATA)
      if (!res.isSuccess) {
        return false
      }
      if (!res.data.length) {
        this.$message.warning('未关联到基础设置的数据')
        return
      }

      // 关联对应的负责人
      // this.form.frontEngineer = res.data?.[0].frontEngineer
      // this.form.backEngineer = res.data?.[0].backEngineer
      this.form.frontDesignersArr = [res.data?.[0].frontEngineer]
      this.form.backDesignersArr = [res.data?.[0].backEngineer]
      this.form.techTester = res.data?.[0].techTester
      this.form.businessTester = res.data?.[0].businessTester
    },
    // 是否可以匹配（可匹配的条件：有填写产品、系统版本、模块、页面）
    isCanMatch() {
      if (
        this.form.menuArgs === '' ||
        this.form.productionVersion === '' ||
        this.form.groupName === '' ||
        this.form.vuePath === ''
      ) {
        this.$message.warning('需填写产品、系统版本、模块、页面后才能匹配')
        return false
      }
      return true
    }
  },
  computed: {
    tableHeight() {
      if (this.approveDisplay) {
        return '225px'
      } else {
        return '100px'
      }
    },
    // 输入框是否禁用
    // isDisabled () {
    // 1.暂时弃用，等有 [节点] 字段再修改该逻辑 ：[当前节点] 不等于 [当前登录人]，弹窗所有输入框都不可输入
    // return false
    // },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    // 是否只显示说明内容
    ifOnlyShowQuestionContent() {
      if (
        this.$store.state?.systemSetting?.ifShowQuestionDetail &&
        this.$store.state.systemSetting.ifShowQuestionDetail === 'yes'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
@button-dv-height: 50px;
@button-bottom-height: 20px;
.edit-dv {
  margin: 0 auto;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 20px;
  padding-bottom: calc(@button-dv-height + @button-bottom-height);
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.button-dv {
  height: @button-dv-height;
  position: absolute;
  bottom: @button-bottom-height;
  left: 50%;
  transform: translate(-50%, 0);
  .fl();

  .save-btn {
    background-color: @primary-color;
    color: @text-color;
  }

  .add-btn {
    width: 100px;
    color: #666;
  }

  .del-btn {
    width: 100px;
    background-color: #ff8b8b;
    color: #fff;
  }
}

.btn-dv-prohibit {
  // cursor: not-allowed;
  transition: none !important;
  opacity: 0.5 !important;
  // color: #c0c4cc;
  // border-color: #ebeef5;
  // background-color: #f2f3f5;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.history-dv {
  margin: 10px auto;
  // background-color: #ffcc66;
  overflow-y: scroll;
  box-sizing: border-box;
  font-size: 14px;

  .scrollbar-mixin();

  .history-title {
    font-size: 16px;
    font-weight: bold;
    color: @able-color;
  }
}

.el-row {
  margin-bottom: 12px !important;
}

.tips {
  color: #aaa;
  margin-bottom: 5px;
}
</style>
